import qs from 'qs';
import { camelCase, snakeCase, isPlainObject } from 'lodash-es';
/**
 *
 * @param {Number} time 秒数，如12秒
 * @param {String} type 返回时间类型，默认返回到分，type:h,返回小时
 */
export const formatSecond = (time, type) => {
  let [h, m, s, _h, _m, _s] = [0, 0, 0, '00', '00', '00'];
  h = Math.floor(time / 3600);
  time = Math.floor(time % 3600);
  m = Math.floor(time / 60);
  s = Math.floor(time % 60);
  _s = s < 10 ? '0' + s : s + '';
  _m = m < 10 ? '0' + m : m + '';
  _h = h < 10 ? '0' + h : h + '';

  // 精确到小时
  if (type === 'h') {
    return _h + ':' + _m + ':' + _s;
  } else {
    return _m + ':' + _s;
  }
};

/**
 * safari 不支持xxxx-xx-xx日期格式
 * 支持xxxx/xx/xx日期格式
 * @param {date | string} d
 */
export function newDate(d) {
  if (typeof d === 'string') {
    d = d.replace(/-/g, '/'); // for safari
  }
  return new Date(d);
}

/*
 * 获取所有url #后面的参数对象
 * @return {Object} 参数对象集合
 */
export function getHashParams() {
  const url = window.location.href;
  const queryHash = url.split('?').pop() || [];
  const pairs = queryHash.split('&'); // 在&处断开
  const args = {};

  for (var i = 0; i < pairs.length; i++) {
    var pos = pairs[i].indexOf('='); // 查找name=value
    if (pos == -1) continue; // 如果没有找到就跳过
    var argname = pairs[i].substring(0, pos); // 提取name
    var value = pairs[i].substring(pos + 1); // 提取value
    args[argname] = decodeURIComponent(value); // url解码并存为属性
  }
  return args;
}

/**
 * 获取url中的参数
 * @param name 参数名
 * @returns string 参数值
 */
export function getUrlParam(name) {
  const reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(&|$)');
  const r = window.location.href.match(reg);
  if (r != null) return decodeURI(r[2]);
  return '';
}

/**
 * 获取url（包括query和hash）中匹配的第一个参数
 * ?a=1#/list?a=2  getUrlParamByName('a') => '1'
 * @param name
 * @returns {*}
 */
export function getUrlParamByName(name) {
  var reg = new RegExp('(\\?|&)' + name + '=([^&#]*)(&|#|$)'); // 构造一个含有目标参数的正则表达式对象

  var search = window.location.href;
  var r = search.match(reg); // 匹配目标参数

  if (r != null) return decodeURI(r[2]);
  return null; // 返回参数值
}

/*
 * 获取所有url参数对象
 * @return {Object} 参数对象集合
 */
export const getAllUrlParams = () => {
  var args = {};
  var query = location.search.substring(1).replace(/&amp;/g, '&'); // 获取查询串，对&字符html解码处理
  var pairs = query.split('&'); // 在&处断开
  for (var i = 0; i < pairs.length; i++) {
    var pos = pairs[i].indexOf('='); // 查找name=value
    if (pos == -1) continue; // 如果没有找到就跳过
    var argname = pairs[i].substring(0, pos); // 提取name
    var value = pairs[i].substring(pos + 1); // 提取value
    args[argname] = decodeURIComponent(value); // url解码并存为属性
  }
  return args; // 返回对象
};

/**
 * 获取url参数集合（包含#前后）
 * @returns {Object} 返回JSON对象集合
 * */
export const getUrlParamsNew = () => {
  let url = window.location.href;
  url = url.replace('/#', '#');
  let arr = url.split('?');
  let obj = {};
  function getObj(url) {
    const str = url;
    let data = {};
    if (str.indexOf('#') > -1) {
      data = qs.parse(str.substring(0, str.indexOf('#')));
    } else {
      data = qs.parse(str);
    }
    return data;
  }
  if (url.indexOf('?') > -1 && arr && arr.length) {
    if (arr.length > 1) {
      arr = arr.slice(1, arr.length);
      arr.forEach(item => {
        obj = Object.assign(obj, getObj(item));
      });
      return obj;
    }
    return obj;
  } else {
    return obj;
  }
};

/**
 * _su参数生成算法
 * 说明：毫秒时间戳 拼接 6位随机数
 * @return {string} 生成字符串
 */
export const createSu = () => {
  function randomNum(lower, upper) {
    return Math.floor(Math.random() * (upper - lower)) + lower;
  }
  var _su = randomNum(100000, 1000000);
  return Date.now() + '' + _su;
};

/**
 * @param {Object} params 包含action及传给调用方的数据
 */
export const webcall = params => {
  try {
    // ios
    if (/iPhone|iPad|iPod|iOS/i.test(navigator.userAgent)) {
      window.webkit.messageHandlers.app.postMessage(JSON.stringify(params));
    }
    // android
    if (window.app && window.app.webcall) {
      window.app.webcall(JSON.stringify(params));
    }
  } catch (error) {
    // console.log(`与app交互失败：${error}`);
  }
};

/**
 * 格式化时间
 * @params {String} format 输出的日期格式
 * @params {String} date   输入的日期, 前端时间戳或者后端时间戳
 * @return {String} 返回格式化后的时间戳
 */
export const formatTime = (format, date) => {
  if (!date) {
    return '';
  }
  if (typeof date === 'number') {
    date = new Date(date);
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds(),
    w: '日一二三四五六'.charAt(date.getDay())
  };
  format = format.replace(/y{4}/, date.getFullYear()).replace(
    /y{2}/,
    date
      .getFullYear()
      .toString()
      .substring(2)
  );
  for (var k in o) {
    var reg = new RegExp(k);
    format = format.replace(reg, match);
  }
  function match(m) {
    return m.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length);
  }
  return format;
};

/**
 * 获取当天日期
 */
export const getNowFormatDate = () => {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = '0' + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate;
  }
  var currentdate = `${year}-${month}-${strDate}`;
  return currentdate;
};

/**
 * 获取多少天后的日期
 * @param {String} beginDate 哪天开始 yyyy-mm-dd
 * @param {Number} day 多少天之后
 * @returns
 */
export const getFormatDate = (beginDate, day) => {
  var y = beginDate.substring(0, 4);
  var m = beginDate.substring(5, 7);
  var d = beginDate.substring(8, 10);
  var date1 = new Date(y, m - 1, d);
  var date = new Date(date1);
  date.setDate(date1.getDate() + day);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = '0' + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate;
  }
  var currentdate = `${year}-${month}-${strDate}`;
  return currentdate;
};

// 日期距离今天还有多少天
export const getDayFromNowToFuture = date => {
  const today = getNowFormatDate();
  const ty = today.substring(0, 4);
  const tm = today.substring(5, 7);
  const td = today.substring(8, 10);
  const tdate = new Date(ty, tm - 1, td);

  const dy = date.substring(0, 4);
  const dm = date.substring(5, 7);
  const dd = date.substring(8, 10);
  const ddate = new Date(dy, dm - 1, dd);

  return (ddate - tdate) / (24 * 60 * 60) / 1000;
};

/**
 * 与app交互
 * @param {Object} json 需要传递的数据
 * json格式 {
 *    action: '',
 *    content: '', // content也是json化的字符串
 *    callback: '' // callback定义到全局window下，供app调用并传递参数给web
 * }
 */
export function web2app(json) {
  try {
    if (/iPhone/i.test(navigator.userAgent)) {
      window.webkit.messageHandlers.app.postMessage(JSON.stringify(json));
    } else {
      // eslint-disable-next-line
      app.webcall(JSON.stringify(json));
    }
  } catch (e) {
    // console.log(e, "web2app交互失败")
    // throw new Error(e)
  }
}

// 2018-12-21 => 2018年12月21日
export function dateForChina(val) {
  const y = val.substring(0, 4);
  const m = val.substring(5, 7);
  const d = val.substring(8, 10);
  return `${y}年${m}月${d}日`;
}

/**
 * 加法运算
 *
 * @param {Number} a
 * @param {Number} b
 */

/* 提示：因为原生js会出现类似：
0.1+0.2=0.30000000000000004
1.3+1.1=2.4000000000000004
的情况。所以共同乘以10的n次方，n为a、b两个数小数部分的最大长度值，这样就能一起化为整数运算
*/
export const add = (a, b) => {
  if (
    a === undefined ||
    a === null ||
    a === '' ||
    b === undefined ||
    b === null ||
    b === ''
  ) {
    console.log('Error: 加法需要传入2个数字');
    return new Error('加法需要传入2个数字');
  }
  let c = 0; // a的小数部分长度
  let d = 0; // b的小数部分长度
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {}
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {}

  const e = 10 ** Math.max(c, d); // 保证a、b为整数的最小10次幂
  return (a * e + b * e) / e;
};

/**
 * 减法运算
 *
 * @param {Number} a
 * @param {Number} b
 */

/* 提示：因为原生js会出现类似：
0.3-0.1=0.19999999999999998
1.3-1=0.30000000000000004
的情况。所以共同乘以10的n次方，n为a、b两个数小数部分的最大长度值，这样就能一起化为整数运算
*/
export const sub = (a, b) => {
  if (
    a === undefined ||
    a === null ||
    a === '' ||
    b === undefined ||
    b === null ||
    b === ''
  ) {
    console.log('Error: 减法运算需要传入2个数字');
    return '减法运算需要传入2个数字';
  }
  let c = 0; // a的小数部分长度
  let d = 0; // b的小数部分长度
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {}
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {}

  const e = 10 ** Math.max(c, d); // 保证a、b为整数的最小10次幂
  return (a * e - b * e) / e;
};

/**
 * 乘法运算
 *
 * @param {Number} a
 * @param {Number} b
 */

/* 提示：因为原生js会出现类似：
1.3*3=3.9000000000000004
5.3*9=47.699999999999996
的情况。所以共同乘以10的n次方，n为a、b两个数小数部分的最大长度值，这样就能一起化为整数运算
*/
export const mul = (a, b) => {
  if (
    a === undefined ||
    a === null ||
    a === '' ||
    b === undefined ||
    b === null ||
    b === ''
  ) {
    console.log('Error: 乘法运算需要传入2个数字');
    return '乘法运算需要传入2个数字';
  }
  let c = 0; // a的小数部分长度
  let d = 0; // b的小数部分长度
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {}
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {}

  return (
    (Number(a.toString().replace('.', '')) *
      Number(b.toString().replace('.', ''))) /
    10 ** (c + d)
  );
};

/**
 * 除法运算
 *
 * @param {Number} a
 * @param {Number} b
 */

/* 提示：因为原生js会出现类似：
0.3/0.1=2.9999999999999996
0.6/3=0.19999999999999998
的情况。所以共同乘以10的n次方，n为a、b两个数小数部分的最大长度值，这样就能一起化为整数运算
*/
export const div = (a, b) => {
  if (
    a === undefined ||
    a === null ||
    a === '' ||
    b === undefined ||
    b === null ||
    b === ''
  ) {
    console.log('Error: 减法运算需要传入2个数字');
    return;
  }
  let c = 0; // a的小数部分长度
  let d = 0; // b的小数部分长度
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {}
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {}

  const fenzi = Number(a.toString().replace('.', '')) * 10 ** (c + d);
  const fenmu = Number(b.toString().replace('.', '')) * 10 ** (c + d);
  return fenzi / fenmu / 10 ** (c - d);
};

// 时间戳转日期格式
function add0(m) {
  return m < 10 ? '0' + m : m;
}
export function formatDate(shijianchuo) {
  // shijianchuo是整数，否则要parseInt转换
  var time = new Date(shijianchuo);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  // var s = time.getSeconds();
  return y + '年' + add0(m) + '月' + add0(d) + ' ' + add0(h) + ':' + add0(mm);
}

// 时间戳转 getyyyyMMdd
export function getyyyyMMdd(time) {
  time = newDate(time);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  if (m >= 1 && m <= 9) {
    m = '0' + m;
  }
  if (d >= 0 && d <= 9) {
    d = '0' + d;
  }
  return `${y}-${m}-${d}`;
}

/**
 * 获取距离指定时间还有多少天
 * @param {String | Number | Date} dateTime 日期时间
 * @example
 * ```javascript
 *     getDistanceSpecifiedTime('2019/02/02 02:02:00');
 *     getDistanceSpecifiedTime(1549036800000);
 *     getDistanceSpecifiedTime(new Date("2019/2/2 00:00:00"));
 * ```
 */
export function getDistanceSpecifiedTime(dateTime) {
  // 指定日期和时间
  var EndTime = new Date(dateTime);
  // 当前系统时间
  var NowTime = new Date();
  var t = EndTime.getTime() - NowTime.getTime();
  var d = Math.floor(t / 1000 / 60 / 60 / 24);
  // var h = Math.floor(t / 1000 / 60 / 60 % 24);
  // var m = Math.floor(t / 1000 / 60 % 60);
  // var s = Math.floor(t / 1000 % 60);
  return d;
}

export function isWx() {
  const ua = navigator.userAgent.toLowerCase();
  // if (encodeURIComponent(ua.match(/MicroMessenger/i)) === 'micromessenger') {
  //   return true;
  // } else {
  //   return false;
  // }
  // 优化
  return encodeURIComponent(ua.match(/MicroMessenger/i)) === 'micromessenger';
}

export function iOSorAndroid() {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isAndroid) {
    return 'android';
  }
  if (isIOS) {
    return 'iOS';
  }
}
export function getCookie(name) {
  const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  const arr = document.cookie.match(reg);
  if (arr) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

// 图片转base64
export function convertImgToBase64(url, callback, outputFormat) {
  let canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const img = new Image();
  img.crossOrigin = 'Anonymous';
  img.onload = function() {
    canvas.height = img.height;
    canvas.width = img.width;
    ctx.drawImage(img, 0, 0);
    const dataURL = canvas.toDataURL(outputFormat || 'image/png');
    callback(dataURL);
    canvas = null;
  };
  img.src = url;
}

/**
 * 将对象字段名称转换为驼峰命名
 * @param {Object} obj
 * @example
 * { foo_bar: 'abc' } => { fooBar: 'abc' }
 */
export function camelCaseAll(obj) {
  if (!isPlainObject(obj) || obj === null) {
    return obj;
  }

  const ret = {};
  for (const key in obj) {
    // eslint-disable-next-line
    if (obj.hasOwnProperty(key)) {
      ret[camelCase(key)] = obj[key];
    }
  }
  return ret;
}

/**
 * 将驼峰命名对象字段转换为下划线格式字段
 * @param {Object} obj
 * @example { fooBar: 'abc' } => { foo_bar: 'abc' }
 */
export function snakeCaseAll(obj) {
  if (!isPlainObject(obj) || obj === null) {
    return obj;
  }

  const ret = {};
  for (const key in obj) {
    // eslint-disable-next-line
    if (obj.hasOwnProperty(key)) {
      ret[snakeCase(key)] = obj[key];
    }
  }
  return ret;
}

/**
 * 解析json字符串为json对象
 * @param data, e.g. "{'a':1}"
 * @returns {any}
 */
export function jsonParse(data) {
  if (!data || typeof data !== 'string') {
    return {};
  }
  // Make sure leading/trailing whitespace is removed (IE can't handle it)
  data = data.trim();
  // Attempt to parse using the native JSON parser first
  if (JSON && JSON.parse) {
    return JSON.parse(data);
  }
  // Make sure the incoming data is actual JSON
  // Logic borrowed from http://json.org/json2.js
  if (
    /^[\],:{}\s]*$/.test(
      data
        .replace(/\\(?:["\\/bfnrt]|u[\da-fA-F]{4})/g, '@')
        .replace(
          /"[^"\\\r\n]*"|true|false|null|-?(?:\d\d*\.|)\d+(?:[eE][-+]?\d+|)/g,
          ']'
        )
        .replace(/(?:^|:|,)(?:\s*\[)+/g, '')
    )
  ) {
    return (function() {
      return data;
    })();
  }
  return {};
}

/**
 * 转化json对象为字符串
 * @param json
 * @returns {*|string}
 */
export function jsonStringify(json) {
  if (typeof JSON === 'object' && JSON.stringify) {
    return JSON.stringify(json);
  }
  return {};
}

/**
 * 截取小数位数，注意不四舍五入
 * @param {number|string} value 数字
 * @param {number} num 保留小数位
 */
export function numFixed(value, n) {
  const index = value.indexOf('.');
  if (index !== -1) {
    value = value.substring(0, index + (n + 1));
  }
  return value;
}

export function hllAppEnv() {
  const hllMatch = navigator.userAgent.match(
    /\/huolala\((\d+),(\w+),([^,]*),([\d\.]+),([^,]+(?:,\d)?),([^,]*),([^,]*)(?:,(\w*),([a-z\.]+))?\)/,
  );
  const result = {};
  if (hllMatch) {
    result.appRevision = +hllMatch[1];
    result.system = hllMatch[2];
    result.appRef = hllMatch[3];
    result.appVersion = hllMatch[4];
    result.deviceModel = hllMatch[5];
    result.deviceInfo = hllMatch[6];
    result.appId = hllMatch[9];
    result.isInApp = true; // 匹配以上正则，即代表在货拉拉系的 APP 中
  }
  return result;
}

/**
 * 是否鸿蒙系统
 * @returns
 */
export function isHarmonyHllApp() {
  console.log('userAgent:', navigator.userAgent);
  console.log('hllAppEnv:', hllAppEnv());
  return hllAppEnv().system === 'harmony';
}
